import { useState } from "react";
import {
  Button,
  Grid,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { post } from "src/utils/networkUtils";

const dateFormat = "YYYY-MM-DD HH:mm:ss";
const defaultListing = {
  price: 100,
  expiresAt: new Date(),
};
export default function PutOnSaleDialog(props) {
  const [listing, setListing] = useState(defaultListing);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setListing((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const onSuccess = () => {
    //props.onSuccessHandler();
    props.onClose();
    props.setLoading(true);
    listing.tenantId = 1;
    listing.userId = props.userId;

    post(`/admin/marketplace/cards/${props.cardId}`, listing).then(function (
      response
    ) {
      props.onSuccessHandler();
    });
  };
  const onCancel = () => {
    props.onClose();
  };

  const handleDateChange = (newValue, fieldName) => {
    setListing((prevState) => ({
      ...prevState,
      [fieldName]: moment(newValue).format(dateFormat),
    }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => {}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Cand on sale</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={3} sx={{ m: 0, p: 1 }}>
            <TextField
              id="price"
              label="Price"
              fullWidth
              value={listing.price}
              variant="standard"
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={9} sx={{ m: 0, p: 1 }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DateTimePicker
                label="End Date"
                value={moment(listing.expiresAt, dateFormat)}
                onChange={(value) => handleDateChange(value, "expiresAt")}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Cancel</Button>
        <Button onClick={() => onSuccess()} autoFocus disabled={false}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
